// Vendor imports
const { connect } = require('react-redux')
// Client V2 common imports
const withImmutableToJS = require('client-v2/common/components/immutable-to-js')
const authModalActions = require('client-v2/common/containers/auth-modal/actions')
const interestModelActions = require('client-v2/common/models/interest/actions')
const deferDispatch = require('client-v2/common/state/dispatch')
const { FetchStateEnum } = require('client-v2/common/utils/enums')
// Container state imports
const { getSlide } = require('../state/selectors')
// Sibling imports
const ArticleProfileInterests = require('./interests-dumb')

function mapStateToProps(state, props) {
  const slide = getSlide(state, props)
  const isLoading = slide.interestsState === FetchStateEnum.LOADING
  return {
    // Flags
    isLoading,
    // Values
    items: slide.interestsItems
  }
}

function mapDispatchToProps(dispatch) {
  const { dispatchAction, dispatchAuthRequiredAction } = deferDispatch(dispatch)
  return {
    onInterestFollowClick: dispatchAuthRequiredAction(
      interestModelActions.toggleFollowing,
      authModalActions.showSignup
    ),
    onInterestNavigate: dispatchAction(interestModelActions.navigateToInterestProfile)
  }
}

// Exports

const SmartComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withImmutableToJS(
    ArticleProfileInterests
  )
)

module.exports = SmartComponent
